class TeamsListController {

    constructor() {
        'ngInject';
    }


    public $onInit = () => {
    }

    public $onChanges = () => {
    
    }
}

export const teamsListComponent = {
    bindings: {
        teams: "<",
        locationId: "<"
    },
    controller: TeamsListController,
    template: require('./teams.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/crm/teams/teams.list.component.ts